import { rest } from 'msw'

export default [
  /**
   * user情報
   */
   rest.get('/swc-api/userinfo', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
        "id": 1,
        "organization_code": "1",
        "organization_name": "S 社",
        "password": "pbkdf2_sha256$260000$XwOiO7IL9u7ZbADGMTSAnW$/PC6jZyUdPkY+Y9A9Of0HU0oZYxyzI838AvI7oqM9rc=",
        "last_login": "2021-12-24T18:16:54.241617+09:00",
        "is_superuser": true,
        "email": "",
        "is_staff": true,
        "is_active": true,
        "date_joined": "2021-12-17T21:03:51.059012+09:00",
        "username": "nishikawa",
        "image": null,
        "first_name": null,
        "last_name": null,
        "favorite_page": null,
        "organization": {
            "code": "1",
            "name": "S 社",
            "customer_type": null,
            "admin": false
        },
        "user_role": {
            "code": 0,
            "name": "Basic",
            "description": ""
        },
        "site": null,
        "pf_area": null,
        "groups": [],
        "user_permissions": [],
        "user_sites": [
            {
              "id": 1,
              "user_id": 1,
              "site_id": 1,
              "user_site_role_id": 2
            },
            {
              "id": 2,
              "user_id": 1,
              "site_id": 2,
              "user_site_role_id": 4
            },
            {
              "id": 3,
              "user_id": 1,
              "site_id": 3,
              "user_site_role_id": 4
            },
            {
              "id": 4,
              "user_id": 1,
              "site_id": 4,
              "user_site_role_id": 4
            },
            {
              "id": 5,
              "user_id": 1,
              "site_id": 5,
              "user_site_role_id": 4
            },
            {
              "id": 6,
              "user_id": 1,
              "site_id": 6,
              "user_site_role_id": 4
            },
            {
              "id": 7,
              "user_id": 1,
              "site_id": 7,
              "user_site_role_id": 4
            },
        ]
    }),
    )
  }),
  /**
   * ユーザ施設ロール情報一覧取得
   */
   rest.get('/swc-api/master/user-site-roles', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": 0,
          "user": 1,
          "site": 1,
          "code": 2,
          "user_site_role": 2147483647
        },
        {
          "id": 1,
          "user": 1,
          "site": 2,
          "code": 4,
          "user_site_role": 2147483647
        },
      ]),
    )
  }),
  /**
   * ユーザロール情報一覧取得
   */
  rest.get('/swc-api/master/user-roles', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
          "code": 0,
          "name": "test",
          "description": "test"
        },
      ]),
    )
  }),
  /**
   * user情報一覧取得
   */
   rest.get('/swc-api/master/users', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": 1,
          "last_name": "津田",
          "first_name": "翼",
          "username": "yoshimoto.akemi@example.com",
          "email": "yoshimoto.akemi@example.com",
          "organization_code": "0",
          "organization_name": "水ing",
          "site": 0,
          "pf_area": 0,
          "user_role_code": 0,
          "user_role_name": "Admin",
          "user_sites": [
          ],
          "is_active": true,
          "enabled": true,
          "status": "string"
        },
        {
          "id": 2,
          "last_name": "西之園",
          "first_name": "浩",
          "username": "yasuhiro.nishinosono@example.com",
          "email": "yasuhiro.nishinosono@example.com",
          "organization_code": "1",
          "organization_name": "BTI",
          "site": 0,
          "pf_area": 0,
          "user_role_code": 1,
          "user_role_name": "Basic",
          "user_sites": [
          ],
          "is_active": true,
          "enabled": true,
          "status": "string"
        },
        {
          "id": 3,
          "last_name": "津田",
          "first_name": "翼",
          "username": "yoshimoto.akemi@example.com",
          "email": "yoshimoto.akemi@example.com",
          "organization_code": "0",
          "organization_name": "水ing",
          "site": 0,
          "pf_area": 0,
          "user_role_code": 0,
          "user_role_name": "Admin",
          "user_sites": [
          ],
          "is_active": true,
          "enabled": true,
          "status": "string"
        },
        {
          "id": 4,
          "last_name": "西之園",
          "first_name": "浩",
          "username": "yasuhiro.nishinosono@example.com",
          "email": "yasuhiro.nishinosono@example.com",
          "organization_code": "1",
          "organization_name": "BTI",
          "site": 0,
          "pf_area": 0,
          "user_role_code": 1,
          "user_role_name": "Basic",
          "user_sites": [
          ],
          "is_active": true,
          "enabled": true,
          "status": "string"
        },
        {
          "id": 5,
          "last_name": "西之園",
          "first_name": "浩",
          "username": "yasuhiro.nishinosono@example.com",
          "email": "yasuhiro.nishinosono@example.com",
          "organization_code": "1",
          "organization_name": "BTI",
          "site": 0,
          "pf_area": 0,
          "user_role_code": 1,
          "user_role_name": "Basic",
          "user_sites": [
          ],
          "is_active": true,
          "enabled": true,
          "status": "string"
        },
      ]),
    )
  }),
  /**
   * ユーザー詳細情報
   */
  rest.get('/swc-api/master/users/:user_id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json({
          "id": 1,
          "last_name": "津田",
          "first_name": "翼",
          "username": "yoshimoto.akemi@example.com",
          "email": "yoshimoto.akemi@example.com",
          "organization_code": "0",
          "organization_name": "水ing",
          "site": 0,
          "pf_area": 0,
          "user_role_code": 0,
          "user_role_name": "Admin",
          "user_sites": [
          ],
          "is_active": true,
          "enabled": true,
          "status": "string"
        }
      ),
    )
  }),
  /**
   * ユーザー情報更新
   */
  rest.patch('/swc-api/master/users/:userId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    const dummy = {
      "favorite_page": '/node/8/dashboard',
    }

    return res(
      ctx.status(200),
      ctx.json(Object.assign(dummy,req.body)),
    )
  }),
  /**
   * ユーザー情報新規登録
   */
  rest.post('/swc-api/master/users', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * ユーザー情報更新
   */
  rest.put('/swc-api/master/users/:userId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
  /**
   * ユーザー情報更削除
   */
  rest.delete('/swc-api/master/users/:userId', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),
]
